<template lang="pug">
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M12 11.0858L18.7929 4.29297L20.2071 5.70718L13.4142 12.5L20.2071 19.2929L18.7929 20.7071L12 13.9142L5.20718 20.7071L3.79297 19.2929L10.5858 12.5L3.79298 5.70718L5.2072 4.29297L12 11.0858Z" fill="#141414"/>
	</svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
